import React, { useState } from 'react'
import CustomModal from 'cms/components/shared/CustomModal';
import UrlEmbed from 'cms/components/UrlEmbed';
import PostPhotoGalleryItemController from '../controller/PostPhotoGalleryItemController';

export default function PostPhotoGalleryItem({ item, showDelete = true, onDelete }) {

    const { modalIsOpen, setModalIsOpen, _delete, } = PostPhotoGalleryItemController(item, onDelete)

    return (
        <>

            <div key={item.id} className="col-md-4 col-sm-4">
                <div className="document-container">
                    <div className="document" onClick={() => { setModalIsOpen(true) }} >
                        <img
                            src={`${item.url}`}
                            className="img-fluid"
                            alt=""
                        />
                    </div>
                    <div className="document-info">
                        <div className="date">
                            {item.created_at.split('T')[0]}
                        </div>
                        <div className="document-info-buttons">
                            {showDelete && <DeleteButton />}
                            {/* <EditButton /> */}
                            {/* <FeaturedButton /> */}
                        </div>
                    </div>
                </div>
            </div>
            {modalIsOpen && (
                <CustomModal
                    isOpen={modalIsOpen}
                    setIsOpen={setModalIsOpen}
                >
                    <>
                        <img
                            src={`${item.url}`}
                            className="img-fluid"
                            alt=""
                        />
                    </>
                </CustomModal>
            )}

        </>

    );

    function DeleteButton() {
        return <div
            className="btn color-white pull-right"
            onClick={() => {
                if (window.confirm('Are you sure you wish to delete this item?'))
                    _delete();
            }}
        >
            {" "}
            <i className="fa fa-trash"></i>
        </div>;
    }

}


